import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    background: {
      default: '#ffffffff', // your global page background
    },
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#bc00f5ff',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

export default theme;
